export const isProviderErrorText = (value: unknown): boolean => {
  if (typeof value !== 'string') return false;
  const normalized = value.toLowerCase();
  return /(\b403\b|\b500\b|forbidden|exception|provider\s+error|internal server error|timeout|eodhd|fmp)/i.test(normalized);
};

export const sanitizeUserWarning = (value: unknown): string | null => {
  const text = typeof value === 'string' ? value.trim() : '';
  if (!text) return null;
  if (isProviderErrorText(text)) return null;
  return text;
};

export const isUnavailableDisplayValue = (value: unknown): boolean => {
  const text = typeof value === 'string' ? value.trim() : '';
  if (!text) return true;
  return /(^|\b)(data\s+unavailable|unavailable|provider\s+coverage\s+limited|fundamental\s+ratios\s+unavailable|earnings\s+calendar\s+unavailable|balance-sheet\s+coverage\s+limited|n\/?a|na|null|unknown)(\b|$)/i.test(text);
};

export const fallbackForLabel = (label: string): string => {
  const normalized = label.toLowerCase();
  if (normalized.includes('earnings')) return 'Earnings calendar unavailable';
  if (normalized.includes('balance') || normalized.includes('financial health')) return 'Balance-sheet coverage limited';
  if (normalized.includes('valuation') || normalized.includes('profitability') || normalized.includes('fundamental')) return 'Fundamental ratios unavailable';
  return 'Provider coverage limited';
};

const parseNumericLike = (value: string): number | null => {
  const normalized = value.replace(/[£,$,%\s]/g, '');
  if (!normalized) return null;
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
};

export const formatLseNumericDisplay = (value: string, exchange: string): string => {
  if (exchange.toUpperCase() !== 'LSE') return value;
  if (/data unavailable/i.test(value)) return 'Provider coverage limited';
  if (/\d{4}-\d{2}-\d{2}/.test(value)) return value;
  const directRange = value.match(/^(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)$/);
  if (directRange) {
    const a = Number(directRange[1]);
    const b = Number(directRange[2]);
    return `£${a.toFixed(4)}-£${b.toFixed(4)}`;
  }
  const numeric = parseNumericLike(value);
  if (numeric == null) return value;
  return `£${numeric.toFixed(4)}`;
};
